"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RecordStatus_Factory = /** @class */ (function () {
    function RecordStatus_Factory() {
    }
    RecordStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            RecordId: model.RecordId,
        };
        return result;
    };
    RecordStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            RecordId: model.RecordId,
        };
        return result;
    };
    return RecordStatus_Factory;
}());
exports.RecordStatus_Factory = RecordStatus_Factory;
